export default __webpack_public_path__ + "static/media/MSLogo_Lg.5557f963.gif";